import {Injectable} from '@angular/core'
import {ConfigService} from './config.service'

@Injectable()
export class LoggerService {

  constructor(private config: ConfigService) {
  }

  notifyError(msg: string): void {
    this.config.get().errorCallback(msg)
  }
}
